// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"3c61a1f5","507":"5fc519c9","701":"3c8558b8","862":"dcdcbdb4","970":"b9d01468"}[chunkId] + ".chunk.js";
};